import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Styles/orderPage.css";
import Popup from "../Components/Popup";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import ReadMoreRoundedIcon from "@mui/icons-material/ReadMoreRounded";
import UpdateRounded from "@mui/icons-material/UpdateRounded";
import { AuthLoginInfo } from "../AuthComponents/AuthLogin";
import config from "../config";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";

function AdsPage() {
  const [adsData, setAdsData] = useState([]);
  const [adsGroupData, setAdsGroupData] = useState([]);
  const [buttonNewPopup, setButtonNewPopup] = useState(false);
  const [buttonShowPopup, setButtonShowPopup] = useState(false);
  const [selectedAd, setSelectedAd] = useState(0);
  const [updatedStatus, setUpdatedStatus] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [newAdSubmitted, setNewAdSubmitted] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [adDetails, setAdDetails] = useState({
    title: "",
    imageLink: "",
    isActive: false,
    groupId: "",
    description: "",
  });

  const [filterActive, setFilterActive] = useState(1);
  const [filterAds, setFilterAds] = useState("");

  const handleSearchChange = (newFilteredData) => {
    console.log("newFilteredData", newFilteredData);
    setFilteredData(newFilteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalAds = filteredData.length;
  const computedAds = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    (currentPage - 1) * itemsPerPage + itemsPerPage
  );

  const handleImageChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      
      // Check file size (2MB = 2 * 1024 * 1024 bytes)
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      if (file.size > maxSize) {
        alert("Kích thước hình ảnh không được vượt quá 2MB. Vui lòng chọn hình ảnh khác.");
        e.target.value = ""; // Clear the file input
        return;
      }
      
      setImageFile(file);

      // Upload image immediately and set imageLink to returned filename
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("file", file);
      formData.append("description", adDetails.title || "ad image");
      formData.append("clientDate", new Date().toISOString());

      try {
        const res = await axios.post(
          `${config.apiEndpoint}/Ad/upload`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );
        // Set the returned filename to imageLink
        setAdDetails({
          ...adDetails,
          imageLink: res.data, // API returns the filename string
        });
      } catch (err) {
        console.error("Image upload failed:", err);
        setAdDetails({
          ...adDetails,
          imageLink: "",
        });
        alert("Image upload failed. Please try again.");
      }
    }
  };

  const addNewAd = () => {
    const token = localStorage.getItem("token");
    const dataJson = JSON.stringify({ description: adDetails.description });
    axios
      .post(
        `${config.apiEndpoint}/Ad`,
        {
          title: adDetails.title,
          imageLink: adDetails.imageLink, // Use the uploaded filename
          isActive: adDetails.isActive,
          groupId: adDetails.groupId,
          data: dataJson,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          setAdDetails({
            title: "",
            imageLink: "",
            isActive: false,
            groupId: "",
            description: "",
          });
          setImageFile(null);
          console.log("New ad added successfully");
          setButtonNewPopup(false);
          setNewAdSubmitted(!newAdSubmitted); // Toggle to trigger useEffect
        }
      })
      .catch((err) => {
        console.error("Error adding new ad:", err);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`${config.apiEndpoint}/AdsGroup`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      })
      .then((res) => {
        setAdsGroupData(res.data);
        console.log("adsGroupData", res.data);
      })
      .catch((err) => {
        console.error("Error fetching ads group:", err);
      });
  }, [newAdSubmitted]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`${config.apiEndpoint}/Ad`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      })
      .then((res) => {
        console.log("adsData", res.data);
        setAdsData(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching ads:", err);
      });
  }, [newAdSubmitted]);

  return (
    <div className="bodyWrap">
      <div className="contentOrderWrap">
        <div className="leftSide">
          <h1>Ads Manager</h1>
          <Pagination
            total={totalAds}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
          <div className="orderNavWrap">
            <div className="orderNav">
              <ul>
                <li
                  className={`${filterActive === 1 ? "active" : ""}`}
                  onClick={() => {
                    setFilterAds("");
                    setFilterActive(1);
                  }}
                >
                  All ads
                </li>
                <li
                  className={`${filterActive === 2 ? "active" : ""}`}
                  onClick={() => {
                    setFilterAds("True");
                    setFilterActive(2);
                  }}
                >
                  Active
                </li>
                <li
                  className={`${filterActive === 3 ? "active" : ""}`}
                  onClick={() => {
                    setFilterAds("False");
                    setFilterActive(3);
                  }}
                >
                  Deactive
                </li>
              </ul>
            </div>
            <div className="addOrderWrap">
              <SearchBar
                data={adsData}
                handleSearchChange={handleSearchChange}
                dataType="ad"
                status={filterAds}
              />
              <button
                className="addOrder"
                onClick={() => {
                  setButtonNewPopup(true);
                }}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
          <div className="orderWrap">
            <table>
              <thead>
                <tr>
                  <th>Ad ID</th>
                  <th>Title</th>
                  <th>Image Link</th>
                  <th>Active</th>
                  <th>Group ID</th>
                  <th>Mô tả</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {computedAds.map((ad) => {
                  let description = "";
                  if (ad.data) {
                    try {
                      const parsedData = JSON.parse(ad.data);
                      description = parsedData.description || "";
                    } catch (e) {
                      description = "";
                    }
                  }
                  return (
                    <tr key={ad.id}>
                      <td>
                        <font className="maincolor">#</font>
                        {ad.id}
                      </td>
                      <td>{ad.title}</td>
                      <td>
                        <img
                          src={config.uploadEndpoint +"/"+ ad.imageLink}
                          alt={ad.title}
                          style={{ width: "100px", height: "auto" }}
                        />
                      </td>
                      <td>{ad.isActive ? "Yes" : "No"}</td>
                      <td>
                        {adsGroupData.find((group) => group.id === ad.groupId)
                          ?.groupName || "Unknown Group"}
                      </td>
                      <td>
                        {description 
                          ? (description.length > 20 
                              ? description.substring(0, 20) + "..." 
                              : description)
                          : "—"}
                      </td>
                      <td className="maincolor">
                        <button
                          className=""
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            const token = localStorage.getItem("token");
                            axios
                              .delete(`${config.apiEndpoint}/ad/${ad.id}`, {
                                headers: { Authorization: `Bearer ${token}` },
                                withCredentials: true,
                              })
                              .then((res) => {
                                if (res.status === 204) {
                                  setNewAdSubmitted(!newAdSubmitted); // Toggle to trigger useEffect
                                  console.log("Ad removed successfully");
                                }
                              })
                              .catch((err) => {
                                console.error("Error removing ad:", err);
                              });
                          }}
                        >
                          <RemoveRoundedIcon />
                        </button>
                        <button
                          className=""
                          onClick={() => {
                            setButtonShowPopup(true);
                            setSelectedAd(adsData.indexOf(ad));
                            // Parse existing data JSON to get description
                            let description = "";
                            if (ad.data) {
                              try {
                                const parsedData = JSON.parse(ad.data);
                                description = parsedData.description || "";
                              } catch (e) {
                                console.log("Could not parse ad data");
                              }
                            }
                            setAdDetails({
                              ...adDetails,
                              description: description,
                            });
                          }}
                        >
                          <ReadMoreRoundedIcon />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Popup trigger={buttonNewPopup} setTrigger={setButtonNewPopup}>
        <div className="popupWrap">
          <div className="productSummary">
            <h3 className="productSummaryLeft">Add new Ads</h3>
          </div>
          <div className="addNewOrderWrap" style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "flex-start" }}>
            <div className="addNewOrderForm" style={{ flex: 1 }}>
              <div className="orderDetails">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Title"
                    className="orderDetailsInput"
                    value={adDetails.title}
                    onChange={(e) =>
                      setAdDetails({
                        ...adDetails,
                        title: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    className="orderDetailsInput"
                    onChange={handleImageChange}
                    required="required"
                  />
                  {adDetails.imageLink && (
                    <span style={{ marginLeft: 10 }}>
                      {adDetails.imageLink}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <input
                    type="checkbox"
                    checked={adDetails.isActive}
                    onChange={(e) =>
                      setAdDetails({
                        ...adDetails,
                        isActive: e.target.checked,
                      })
                    }
                  />
                  <label>Active</label>
                </div>
                <div className="input-group">
                  <select
                    className="orderDetailsSelect"
                    value={adDetails.groupId}
                    onChange={(e) =>
                      setAdDetails({
                        ...adDetails,
                        groupId: e.target.value,
                      })
                    }
                    required="required"
                  >
                    <option value="">Select Group</option>
                    {adsGroupData.map((group) => (
                      <option key={group.id} value={group.id}>
                        {group.groupName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="addNewOrderForm" style={{ flex: 1 }}>
              <div className="orderDetails">
                <div className="input-group">
                  <textarea
                    placeholder="Mô tả"
                    className="orderDetailsInput"
                    value={adDetails.description}
                    onChange={(e) =>
                      setAdDetails({
                        ...adDetails,
                        description: e.target.value,
                      })
                    }
                    rows="4"
                    style={{ minHeight: "200px", resize: "vertical", width: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button className="submitNewOrderBtn" onClick={() => addNewAd()}>
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>

      <Popup trigger={buttonShowPopup} setTrigger={setButtonShowPopup}>
        <div className="popupWrap">
          <div className="productSummary">
            <h3 className="productSummaryLeft">Edit Ads</h3>
          </div>
          <div className="addNewOrderWrap" style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "flex-start" }}>
            <div className="addNewOrderForm" style={{ flex: 1 }}>
              <div className="orderDetails">
                {adsData[selectedAd] && (
                  <div className="input-group">
                    <img
                      src={config.uploadEndpoint +"/"+ adsData[selectedAd].imageLink}
                      alt={adsData[selectedAd].title}
                      style={{ width: "300px", height: "auto" }}
                    />
                  </div>
                )}
                <div className="input-group">
                  <select
                    className="orderDetailsSelect"
                    value={adsData[selectedAd] ? adsData[selectedAd].groupId : ""}
                    onChange={(e) => {
                      if (adsData[selectedAd]) {
                        const updatedAd = {
                          ...adsData[selectedAd],
                          groupId: e.target.value
                        };
                        const newAdsData = [...adsData];
                        newAdsData[selectedAd] = updatedAd;
                        setAdsData(newAdsData);
                      }
                    }}
                    required="required"
                  >
                    <option value="">Select Group</option>
                    {adsGroupData.map((group) => (
                      <option key={group.id} value={group.id}>
                        {group.groupName}
                      </option>
                    ))}
                  </select> 
                </div>
              </div>
              <div
                className="productSummaryRight newUserSwitch"
                style={{ width: "100%" }}
              >
                <h3>Is Active </h3>
                <input
                  type="radio"
                  name="rdo"
                  id="yes"
                  onChange={() => setUpdatedStatus(true)}
                  defaultChecked="defaultChecked"
                />
                <input
                  type="radio"
                  name="rdo"
                  id="no"
                  onChange={() => setUpdatedStatus(false)}
                />
                <div className="switch">
                  <label className="switchLabel" htmlFor="yes">
                    Yes
                  </label>
                  <label className="switchLabel" htmlFor="no">
                    No
                  </label>
                  <span></span>
                </div>
              </div>
            </div>
            <div className="addNewOrderForm" style={{ flex: 1 }}>
              <div className="orderDetails">
                <div className="input-group">
                  <textarea
                    placeholder="Mô tả"
                    className="orderDetailsInput"
                    value={adDetails.description}
                    onChange={(e) =>
                      setAdDetails({
                        ...adDetails,
                        description: e.target.value,
                      })
                    }
                    rows="4"
                    style={{ minHeight: "200px", resize: "vertical", width: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => {
                  const token = localStorage.getItem("token");
                  const dataJson = JSON.stringify({ description: adDetails.description });
                  console.log("selectedAd", adsData[selectedAd]);
                  console.log("updatedStatus", updatedStatus);
                  axios
                    .put(
                      `${config.apiEndpoint}/Ad/${adsData[selectedAd].id}`,
                      {
                        id: adsData[selectedAd].id,
                        title: adsData[selectedAd].title,
                        imageLink: adsData[selectedAd].imageLink,
                        groupId: adsData[selectedAd].groupId,
                        isActive: updatedStatus,
                        data: dataJson,
                      },
                      {
                        headers: { Authorization: `Bearer ${token}` },
                        withCredentials: true,
                      }
                    )
                    .then((res) => {
                      if (res.status === 204) {
                        setNewAdSubmitted(!newAdSubmitted); // Toggle to trigger useEffect
                        setButtonShowPopup(false);
                        console.log("Ad updated successfully");
                      }
                    })
                    .catch((err) => {
                      console.error("Error updating ad:", err);
                    });
                }}
              >
                <UpdateRounded />
                <span className="addOrderText">Update</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default AdsPage;
